/**
 * 경로(pathname) → 사람이 읽는 화면 이름.
 *
 * 원래 Layout.js 안에만 있었는데, AI 어시스턴트 패널도 "지금 어느 화면의 대화인지" 를
 * 보여주려고 같은 이름이 필요해졌다. Layout 은 AiChatPanel 을 import 하므로 거기서
 * 다시 가져오면 순환 import 가 된다. 그래서 공용 유틸로 뺐다.
 */
export const getWorkTabLabel = (pathname) => {
  if (!pathname) return '작업 탭';

  const staticRouteLabels = {
    '/products/tour': '투어 리스트',
    '/products/hotel': '호텔 리스트',
    '/products/single': '단품 리스트',
    '/products/quote': '견적 상품',
    '/reservations': '예약 관리',
    '/quotes': '상담 관리',
    '/schedule': '일정 관리',
    '/settlements': '예약 관리',
    '/settings/clients': '거래처 관리',
    '/settings/partners': '공급사 관리',
    '/settings/accounts': '통장 관리',
    '/settings/pg-transactions': 'PG 거래내역',
    '/settings/shared-inventory': '공유재고 관리',
    '/settings/product-codes': '상품코드 관리',
    '/settings/promotions': '기획전 관리',
    '/settings/outgoing-mail': '발신메일 관리',
    '/settings/group-settlement': '단체정산',
    '/analytics/clarity': '방문 통계',
    '/quick-wizard': '빠른 등록',
    '/quotes/open': '공개 견적 요청(개발중)',
    '/manuals': '메뉴얼',
  };

  if (staticRouteLabels[pathname]) return staticRouteLabels[pathname];

  if (pathname.startsWith('/manuals/')) return '메뉴얼';

  if (pathname.startsWith('/price-stock/')) return '가격/재고';
  if (pathname.startsWith('/detail-settings/')) return '상세페이지 설정';
  if (pathname.startsWith('/orders/')) return '예약자 목록';
  if (pathname.startsWith('/reservation-detail/')) return '예약 상세';
  if (pathname.startsWith('/other-company-reservation-detail/')) return '타사상품 판매 상세';
  if (pathname.startsWith('/quote-detail/')) return '상담 상세';
  if (pathname.startsWith('/general/price-stock/')) return '일반 가격/재고';
  if (pathname.startsWith('/general/detail-settings/')) return '일반 상세페이지 설정';
  if (pathname.startsWith('/general/orders/')) return '일반 예약자 목록';

  return pathname;
};

/**
 * 화면 이름에 대상 번호를 붙여 준다. (예: "가격/재고 · 111366")
 * 같은 화면이라도 상품/예약이 다르면 다른 대화로 다루기 위해 쓴다.
 */
export const getRouteLabelWithId = (pathname) => {
  const label = getWorkTabLabel(pathname);
  if (label === pathname) return label; // 매핑 없는 경로는 그대로
  const last = String(pathname || '').split('/').filter(Boolean).pop();
  if (last && /^\d+$/.test(last)) return `${label} · ${last}`;
  return label;
};
